import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { CfgPage } from '../pages/cfg/cfg';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Http, HttpModule } from '@angular/http';
import { CfgService } from './door/cfgService';
import { StatusService } from './door/statusService';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    CfgPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    HttpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    CfgPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    CfgService,
    StatusService
  ]
})
export class AppModule {
  // constructor(private doorService: DoorService) {

  // }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts